import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {
    createReferenceDescription,
    deleteReferenceDescriptions,
    getReferenceDescriptions,
    selectReferenceDescriptions
} from "../../redux/reducers/handbook-edit-reducer.js";
import {getActiveEnvironmentState, loadingActiveEnvironmentState} from "../../redux/reducers/master-of-acts-reducer.js";
import {
    getFolderNodes,
    selectFolderNodes,
    selectNormativeDocuments
} from "../../redux/reducers/normative-documents-reducer.js";
import HandbooksTable from "../../components/HandbooksTable/HandbooksTable.jsx";
import {GridCellExpand} from "../../components/GridCellExpand/GridCellExpand.jsx";
import {useDialog} from "../../hooks/useDialog.js";
import HandbookDialog from "../../components/HandbookEditDialogs/HandbookDialog.jsx";

const HandbookEditContainer = () => {
    const {projectID} = useParams()

    const dispatch = useDispatch()

    const folderNodes = useSelector(selectFolderNodes)
    const environmentState = useSelector(getActiveEnvironmentState)
    const referenceDescriptions = useSelector(selectReferenceDescriptions)
    const normativeDocuments = useSelector(selectNormativeDocuments)

    const handbookDialog = useDialog()

    useEffect(() => {
        if (projectID) {
            dispatch(loadingActiveEnvironmentState(projectID))
        }
    }, [dispatch])

    useEffect(() => {
        if (environmentState) {
            dispatch(getReferenceDescriptions(environmentState.handbook))
        }
    }, [environmentState])

    useEffect(() => {
        if (normativeDocuments.length === 0) {
            dispatch(getFolderNodes())
        }
    }, [dispatch])

    const columns = [
        {
            field: 'sequenceNumber',
            headerName: '№',
            flex: 0.15,
        },
        {
            field: 'normative_document',
            headerName: 'Документ',
            flex: 1,
            renderCell: ({value, colDef}) => (
                <GridCellExpand
                    value={value ? normativeDocuments.find(doc => doc.id === value)?.name : ''}
                    width={colDef.computedWidth}
                />
            )
        },
        {
            field: 'description',
            headerName: 'Описание ссылки',
            flex: 1,
            renderCell: ({value, colDef}) => (
                <GridCellExpand
                    value={value ? value.toString() : ''}
                    width={colDef.computedWidth}
                />
            )
        }
    ]

    return (
        <>
            <HandbookDialog
                open={handbookDialog.open}
                onClose={handbookDialog.handleClose}
                folderNodes={folderNodes}
                documents={normativeDocuments}
                submitCallback={async (values) => {
                    await dispatch(createReferenceDescription({...values, handbook: environmentState?.handbook}))
                    await dispatch(loadingActiveEnvironmentState(projectID))
                }}
            />
            <HandbooksTable
                rows={referenceDescriptions}
                columns={columns}
                loading={false}
                onRowDelete={async (rows) => {
                    await dispatch(deleteReferenceDescriptions(rows))
                    await dispatch(loadingActiveEnvironmentState(projectID))
                }}
                onAddButtonClick={handbookDialog.handleOpen}
            />
        </>
    );
};

export default HandbookEditContainer;